export default [
  { name: 'Auckland', code: 'AUK' },
  { name: 'Bay of Plenty', code: 'BOP' },
  { name: 'Canterbury', code: 'CAN' },
  { name: 'Chatham Islands', code: 'CIT' },
  { name: 'Gisborne', code: 'GIS' },
  { name: 'Hawke’s Bay', code: 'HKB' },
  { name: 'Manawatu-Wanganui', code: 'MWT' },
  { name: 'Marlborough', code: 'MBH' },
  { name: 'Nelson', code: 'NSN' },
  { name: 'Northland', code: 'NTL' },
  { name: 'Otago', code: 'OTA' },
  { name: 'Southland', code: 'STL' },
  { name: 'Taranaki', code: 'TKI' },
  { name: 'Tasman', code: 'TAS' },
  { name: 'Waikato', code: 'WKO' },
  { name: 'Wellington', code: 'WGN' },
  { name: 'West Coast', code: 'WTC' }
];
